const TEAM_ORDER = ["red", "blue", "green", "yellow", "orange", "purple", "pink", "cyan", "lime", "brown"];

const definitions = {
  laser_shot: { controller: "/laser_shot/index.html", start: "startGame", join: "SpawnPlayer", leave: "RemovePlayer", joinKind: "name" },
  carball: { controller: "/carball/index.html", start: "StartGame", join: "JoinPlayer", leave: "LeavePlayer", joinKind: "teamPipe" },
  car_race: { controller: "/car_race/index.html", start: "StartGame", join: "JoinPlayer", leave: "LeavePlayer", joinKind: "teamPipe" },
  ring_guard: { controller: "/ring_guard/index.html", start: "StartGame", join: "SpawnPlayer", leave: "RemovePlayer", joinKind: "name" },
  curling: { controller: "/curling/index.html", start: "StartGame", join: "JoinPlayer", leave: "LeavePlayer", joinKind: "name" },
  foosball: { controller: "/foosball/index.html", start: "StartGame", join: "JoinPlayer", leave: "LeavePlayer", joinKind: "teamPipe" },
  football: { controller: "/football/index.html", start: "StartGame", join: "SpawnPlayer", leave: "RemovePlayer", joinKind: "football" },
  eggs_fight: { controller: "/eggs_fight/index.html", start: "StartGame", join: "JoinPlayer", leave: "LeavePlayer", joinKind: "teamPipe" },
  headball: { controller: "/headball/index.html", start: "StartGame", join: "JoinPlayer", leave: "LeavePlayer", joinKind: "teamPipe" },
  ice_billiards: { controller: "/ice_billiards/index.html", start: "StartGame", join: "JoinPlayer", leave: "LeavePlayer", joinKind: "teamPipe" },
  marble_sling: { controller: "/marble_sling/index.html", start: "StartGame", join: "JoinPlayer", leave: "LeavePlayer", joinKind: "name" },
  math_race: { controller: "/math_race/index.html", start: "StartGame", join: "JoinTournamentPlayer", leave: "DisconnectTournamentPlayer", joinKind: "name" },
  pong3D: { controller: "/pong3d/index.html", start: "StartGame", join: "SpawnPlayer", leave: "RemovePlayer", joinKind: "name" },
  running_race: { controller: "/running_race/index.html", start: "StartGame", join: "JoinPlayers", leave: "LeavePlayers", joinKind: "multi" },
  shooter_royal: { controller: "/shooter_royal/index.html", start: "StartMatch", join: "JoinPlayer", leave: "LeavePlayer", joinKind: "teamPipe" },
  table_hockey: { controller: "/table_hockey/index.html", start: "StartGame", join: "JoinPlayer", leave: "LeavePlayer", joinKind: "name" },
  uno: { controller: "/uno/index.html", start: "StartGame", join: "JoinPlayer", leave: "LeavePlayer", joinKind: "name" },
  snake: { controller: "/snake/index.html", start: "StartGame", join: "JoinPlayer", leave: "LeavePlayer", joinKind: "teamPipe" },
};

const aliases = {
  lasershot: "laser_shot", aimshoot: "laser_shot",
  carball: "carball", carrace: "car_race", "car-race": "car_race",
  circleprotect: "ring_guard", ringguard: "ring_guard",
  curling2d: "curling", football2d: "football", grenadelaunchers: "eggs_fight", eggsfight: "eggs_fight",
  icebilliards: "ice_billiards", marbelzones2d: "marble_sling", marblesling: "marble_sling", pong3d: "pong3D",
  runjump: "running_race", runningrace: "running_race", shooter: "shooter_royal", shooterroyal: "shooter_royal", tablehockey: "table_hockey",
  wormclassic: "snake", mathrace: "math_race",
};

export function resolveGameKey(game) {
  const explicit = game?.integration_key;
  if (explicit && definitions[explicit]) return explicit;
  const normalized = String(game?.title || "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
  return aliases[normalized] || explicit || normalized;
}

export function getGameDefinition(gameKey) {
  return definitions[gameKey] || null;
}

export function getControllerUrl(gameKey) {
  return definitions[gameKey]?.controller || null;
}

function unitySend(instance, method, payload) {
  if (!instance || !method) return;
  if (payload === undefined) instance.SendMessage("Manager", method);
  else instance.SendMessage("Manager", method, String(payload));
}

function sideFor(team) {
  const index = Math.max(0, TEAM_ORDER.indexOf(team));
  return index % 2 === 0 ? "TeamA" : "TeamB";
}

function joinPayload(definition, participant) {
  const side = sideFor(participant.team);
  if (definition.joinKind === "teamPipe") return `${side}|${participant.name}`;
  if (definition.joinKind === "football") return `${side === "TeamA" ? "True" : "False"},${participant.name}`;
  return participant.name;
}

export function populateUnity(instance, gameKey, roster) {
  const definition = definitions[gameKey];
  if (!definition) throw new Error(`No tournament adapter for ${gameKey}`);
  const participants = Object.values(roster?.participants || {}).filter((item) => !item.eliminated);
  if (definition.joinKind === "multi") {
    unitySend(instance, definition.join, participants.map((item) => item.name).join(";"));
    return;
  }
  participants.forEach((participant) => unitySend(instance, definition.join, joinPayload(definition, participant)));
}

export function addControllerToUnity(instance, gameKey, roster, controllerId) {
  const definition = definitions[gameKey];
  if (!definition) return;
  const participants = Object.values(roster?.participants || {}).filter((item) => item.controller_id === controllerId && !item.eliminated);
  if (definition.joinKind === "multi") {
    if (participants.length) unitySend(instance, definition.join, participants.map((item) => item.name).join(";"));
    return;
  }
  participants.forEach((participant) => unitySend(instance, definition.join, joinPayload(definition, participant)));
}

export function removeControllerFromUnity(instance, gameKey, roster, controllerId) {
  const definition = definitions[gameKey];
  if (!definition) return;
  const participants = Object.values(roster?.participants || {}).filter((item) => item.controller_id === controllerId && !item.eliminated);
  if (definition.joinKind === "multi") {
    if (participants.length) unitySend(instance, definition.leave, participants.map((item) => item.name).join(";"));
    return;
  }
  participants.forEach((participant) => unitySend(instance, definition.leave, participant.name));
}

export function startUnityRound(instance, gameKey) {
  const definition = definitions[gameKey];
  unitySend(instance, definition?.start);
}

function parsePayload(payload) {
  const raw = String(payload || "").trim();
  const split = raw.indexOf(" ");
  return split < 0
    ? { category: raw, params: "" }
    : { category: raw.slice(0, split), params: raw.slice(split + 1) };
}

export function dispatchControllerInput(instance, gameKey, participant, payload) {
  if (!instance || !participant || participant.eliminated) return;
  const { category, params } = parsePayload(payload);
  const name = participant.name;
  const values = params.split(/[, ]+/).filter(Boolean);

  if (category === "PlayerInfo" || category === "Start") return;
  switch (gameKey) {
    case "laser_shot":
      if (category === "Aim") unitySend(instance, "aim", `${name},${params}`);
      if (category === "Shoot") unitySend(instance, "shoot", name);
      break;
    case "carball":
    case "car_race":
      if (category === "Move" || category === "Drive") unitySend(instance, "SetPlayerInput", `${name},${values[0] || 0},${values[1] || 0},${values[2] || 0}`);
      if (category === "Brake") unitySend(instance, "SetPlayerInput", `${name},0,0,1`);
      break;
    case "ring_guard":
      if (category === "Move") unitySend(instance, "MovePlayer", `${name},${params}`);
      break;
    case "curling":
      if (category === "Move") unitySend(instance, "MoveMarbel", `${name},${values[0] || 0},${values[1] || 0}`);
      if (category === "Shoot") unitySend(instance, "Slide", `${name},${values[0] || 0},${values[1] || 0},${values[2] || 0}`);
      break;
    case "foosball":
      if (category === "RodMove" || category === "RodRotate") unitySend(instance, "MoveHandle", `${category} ${values[0] || 0},${values[1] || 0},${name}`);
      if (category === "LetGo") unitySend(instance, "LetGoHandle", params);
      break;
    case "football":
      if (category === "Move") unitySend(instance, "MovePlayer", `${name},${params}`);
      if (category === "Shoot") unitySend(instance, "Shoot", `${name},${params}`);
      break;
    case "eggs_fight":
      if (["Move", "Jump", "Aim"].includes(category)) unitySend(instance, `${category}Player`, `${name},${values[0] || 0},${values[1] || 0},${values[2] || 1}`);
      if (category === "Shoot") unitySend(instance, "ShootPlayer", name);
      if (category === "SelectMap") unitySend(instance, "SelectMap", params);
      break;
    case "headball":
      if (category === "Move") unitySend(instance, "MovePlayer", `${name},${values[0] || 0}`);
      if (category === "Jump") unitySend(instance, "PlayerJump", name);
      break;
    case "ice_billiards":
      if (category === "Move") unitySend(instance, "MovePallet", `${name},${values[0] || 0},${values[1] || 0}`);
      if (category === "Shoot") unitySend(instance, "Slide", `${name},${values[0] || 0},${values[1] || 0}`);
      break;
    case "marble_sling":
      if (category === "Load") unitySend(instance, "playerLoadMarbel", `${name},${params}`);
      if (category === "Aim") unitySend(instance, "playerAim", `${name},${params}`);
      if (category === "Shoot") unitySend(instance, "playerShoot", name);
      break;
    case "math_race": {
      let message;
      try { message = JSON.parse(String(payload || "")); }
      catch (_) { return; }
      if (message.type === "answer" && Number.isSafeInteger(message.value)) {
        unitySend(instance, "SubmitTournamentAnswer", `${name}|${message.value}`);
      }
      break;
    }
    case "pong3D":
      if (category === "Move") unitySend(instance, "MovePaddle", `${name},${params}`);
      break;
    case "running_race":
      String(payload || "").split(";").forEach((command) => {
        const parsed = parsePayload(command);
        const playerName = parsed.params || name;
        if (parsed.category === "Step") unitySend(instance, "HandleStep", playerName);
        if (parsed.category === "Jump") unitySend(instance, "HandleJump", playerName);
      });
      break;
    case "shooter_royal":
      if (category === "Move") unitySend(instance, "MovePlayer", `${name},${values[0] || 0},${values[1] || 0}`);
      if (category === "Aim") unitySend(instance, "AimPlayer", `${name},${values[0] || 0},${values[1] || 0}`);
      if (category === "Shoot") unitySend(instance, "ShootPlayer", name);
      break;
    case "table_hockey":
      if (category === "Move") unitySend(instance, "MovePaddle", `${name},${values[0] || 0},${values[1] || 0}`);
      if (category === "Shoot") unitySend(instance, "PlayerShoot", name);
      break;
    case "uno":
      if (category === "Play") unitySend(instance, "ChooseCard", `${name},${values[0] || 0}`);
      if (category === "Draw") unitySend(instance, "RequestDraw", name);
      if (category === "WildChoice") unitySend(instance, "SubmitWildChoice", `${name},${values[0] || "Red"},${values[1] || 0}`);
      if (category === "Pass") unitySend(instance, "PassAfterDraw", name);
      break;
    case "snake":
      if (["Move", "Direction", "Turn"].includes(category)) unitySend(instance, "SetPlayerDirection", `${name},${values.join(",")}`);
      break;
    default:
      console.warn("Unhandled tournament controller input", gameKey, payload);
  }
}

export { TEAM_ORDER };
